import { Flex } from "@mantine/core";

import { useDashboardNextMonthDue } from "../../../api/hooks/collectionDashboard/useDashboardNextMonthDue.ts";
import SectionTitle from "../../../components/Section/SectionTitle/SectionTitle.tsx";
import Table from "../../../components/Table/Table.tsx";
import { useStyles } from "../CollectionDashboardPage.styles.ts";
import { CollectionDashboardFilter } from "../types.ts";
import { useNextMonthDueTeamTableData } from "./hooks/useNextMonthDueTeamTableData.tsx";

interface NextMonthDuePerSalesTeamProps {
  filter: CollectionDashboardFilter;
}

const NextMonthDuePerSalesTeam = ({
  filter,
}: NextMonthDuePerSalesTeamProps) => {
  const { classes } = useStyles();

  const [{ data, fetching }] = useDashboardNextMonthDue(filter);

  const [columns, rows] = useNextMonthDueTeamTableData({
    data: data?.dashboardNextMonthDue,
  });

  return (
    <Flex direction="column" gap={12}>
      <SectionTitle variant="golden" flex={0} className={classes.sectionTitle}>
        Next Month Due Invoice per Sales team
      </SectionTitle>

      <Table
        columns={columns}
        rows={rows}
        minWidth={"100%"}
        loading={fetching}
      />
    </Flex>
  );
};

export default NextMonthDuePerSalesTeam;
